/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwf_Dates_NoteInputs */

const en_pwf_dates_note = /** @type {(inputs: Pwf_Dates_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Started and completed dates adjust to the category of each new status.`)
};

const de_pwf_dates_note = /** @type {(inputs: Pwf_Dates_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start- und Abschlussdatum passen sich der Kategorie des neuen Status an.`)
};

/**
* | output |
* | --- |
* | "Started and completed dates adjust to the category of each new status." |
*
* @param {Pwf_Dates_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pwf_dates_note = /** @type {((inputs?: Pwf_Dates_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwf_Dates_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pwf_dates_note(inputs)
	return en_pwf_dates_note(inputs)
});